// Google Maps URL helpers.
//
// These use Google's keyless `output=embed` form rather than the official Maps
// Embed API, which requires an API key and an enabled billing account. This
// project has no Maps key configured (.env carries only REACT_APP_API_URL).
// If a key is added later, switch buildMapEmbedSrc over to
// https://www.google.com/maps/embed/v1/place?key=...&q=... - the call sites
// won't need to change.
//
// `query` is geocoded by Google, so precision depends entirely on how specific
// the text is. Pass "lat,lng" instead of an address when an exact pin matters.

export const buildMapEmbedSrc = (query, zoom = 14) =>
  `https://maps.google.com/maps?q=${encodeURIComponent(
    query
  )}&z=${zoom}&output=embed`;

export const buildMapDirectionsUrl = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
